module.exports = __webpack_public_path__ + "static/media/Rayna Wang.9e206f65.png";